import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svc-ptn',
  templateUrl: './ptn.component.html',
  styleUrls: ['./ptn.component.scss']
})
export class PtnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
